/* eslint-disable comma-dangle */

export default {
    address: [
        'user-input',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'area-land',
        'land-status',
        'permitted-use-type',
        'has-investment-project',
        'has-encumbrances',
        'land-electricity',
        'land-gas',
        'land-drainage',
        'land-water',
        'driveway-type'
    ],
    'about-building': [],
    'price-and-deal-terms': [
        'price-sale',
        'agent-bonus'
    ]
};
